// Product image zoom/unzoom (prevent cart or menu button from being clicked when zoomed in on an image)
$('.pswp__button--close').on('pswpTap', function (event) {
    event.stopPropagation()
})

$(document).ready( function() {
    $('.main-navigation .sub-menu li.menu-item-has-children > a, .slicknav_nav .sub-menu li.menu-item-has-children > a, .category-list a.has-children').each( function() {
        $(this).append('<span class="arrow"></span>')
    })

    $('.main-navigation .sub-menu li.menu-item-has-children > a .arrow, .slicknav_nav .sub-menu li.menu-item-has-children > a .arrow, .category-list a.has-children .arrow').click( function(e) {
        e.preventDefault()
        var submenu = $(this).parent().next('.sub-menu')
        if( $(this).hasClass('open') ) {
            $(this).removeClass('open')
        } else {
            $(this).addClass('open')
        }
        submenu.slideToggle()
    })

    $('.category-list .mobile-menu-button').click( function() {

        if( $(this).hasClass('open') ) {
            $(this).removeClass('open')
        } else {
            $(this).addClass('open')
        }

        $(this).parents('.category-list').find('.category-menu').slideToggle()
    })

    // Scroll to "Tuotteet" section when "Kaikki tuotteet" is clicked
    $('.scroll-to-products').click( function(e) {
        e.preventDefault()
        const tuotteetSection = document.getElementById('tuotteet-section')
        if (tuotteetSection) {
            tuotteetSection.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
    })
})


// Infinite scroll for products (requires ProductsInfiniteVars localized in footer)
$(document).ready( function() {
    if ( typeof ProductsInfiniteVars === 'undefined' ) return;

    let currentPage = parseInt(ProductsInfiniteVars.current_page, 10) || 1;
    let maxPages = parseInt(ProductsInfiniteVars.max_pages, 10) || 1;
    const postsPerPage = parseInt(ProductsInfiniteVars.posts_per_page, 10) || 36;
    const ajaxUrl = ProductsInfiniteVars.ajax_url;
    const containerSelector = ProductsInfiniteVars.container || '.products';
    let loading = false;
    let finished = currentPage >= maxPages;
    let totalResults = parseInt(ProductsInfiniteVars.total_results, 10) || 0;

    // small helper to append HTML into the existing product wrapper
    function appendProducts(html) {
        const container = document.querySelector(containerSelector);
        if (!container) {
            console.warn('ProductsInfinite: container not found:', containerSelector);
            return;
        }

        const temp = document.createElement('div');
        temp.innerHTML = html.trim();

        // 1) Try to find product nodes inside the returned HTML
        const productNodes = temp.querySelectorAll('.product');

        // Helper to prepare an image: ensure it reserves space and lazy-loads
        function prepImages(node) {
            const imgs = node.querySelectorAll('img');
            imgs.forEach(img => {
                // ensure lazy loading
                try { if (!img.getAttribute('loading')) img.setAttribute('loading', 'lazy'); } catch(e){}
                // if width/height attributes missing, apply a CSS aspect-ratio fallback (already in CSS),
                // and ensure image fits container
                if (!img.getAttribute('width') && !img.getAttribute('height')) {
                    // leave aspect-ratio css to handle it; ensure style won't break layout
                    img.style.width = img.style.width || '100%';
                    img.style.height = img.style.height || 'auto';
                }
            });
        }

        if (productNodes && productNodes.length) {
            const appendedEls = [];

            productNodes.forEach(node => {
                // mark new nodes so we can animate them after images load
                node.classList.add('products-infinite-new');
                prepImages(node);

                // append correctly depending on container type
                if (container.tagName === 'UL' || container.tagName === 'OL') {
                    if (node.tagName === 'LI') {
                        container.appendChild(node);
                        appendedEls.push(node);
                    } else {
                        const li = document.createElement('li');
                        li.className = 'product products-infinite-new';
                        li.innerHTML = node.innerHTML;
                        container.appendChild(li);
                        appendedEls.push(li);
                    }
                } else {
                    container.appendChild(node);
                    appendedEls.push(node);
                }
            });

            // Wait for images inside the appended elements to finish loading (or be already complete)
            const imgs = [];
            appendedEls.forEach(el => imgs.push(...Array.from(el.querySelectorAll('img'))));

            const imgPromises = imgs.map(img => new Promise(resolve => {
                if (img.complete) {
                    // small timeout to let browser layout apply before resolving
                    setTimeout(resolve, 10);
                } else {
                    img.addEventListener('load', function onL() { img.removeEventListener('load', onL); resolve(); });
                    img.addEventListener('error', function onE() { img.removeEventListener('error', onE); resolve(); });
                }
            }));

            // If there are no images, still animate in on next frame
            const ready = imgPromises.length ? Promise.all(imgPromises) : new Promise(r => requestAnimationFrame(r));

            ready.then(() => {
                // Fade-in / enable pointer events. Use a tiny timeout to ensure layout settles.
                requestAnimationFrame(() => {
                    appendedEls.forEach(el => {
                        el.classList.remove('products-infinite-new');
                        el.style.pointerEvents = ''; // re-enable
                    });
                });
            });

            return;
        }

        // 2) Fallback: if AJAX returned an inner .products wrapper, move its children
        const returnedProductsList = temp.querySelector(containerSelector) || temp.querySelector('.products');
        if (returnedProductsList && returnedProductsList.children.length) {
            Array.from(returnedProductsList.children).forEach( child => {
                // mark new nodes for animation & prep images
                child.classList.add('products-infinite-new');
                prepImages(child);

                container.appendChild(child);
            });

            // same image-ready fade-in as above
            const imgs = Array.from(container.querySelectorAll('.products-infinite-new img'));
            const imgPromises = imgs.map(img => new Promise(resolve => {
                if (img.complete) setTimeout(resolve, 10);
                else { img.addEventListener('load', function onL(){ img.removeEventListener('load', onL); resolve(); }); img.addEventListener('error', function onE(){ img.removeEventListener('error', onE); resolve(); }); }
            }));
            const ready = imgPromises.length ? Promise.all(imgPromises) : new Promise(r => requestAnimationFrame(r));
            ready.then(() => requestAnimationFrame(() => {
                container.querySelectorAll('.products-infinite-new').forEach(el => el.classList.remove('products-infinite-new'));
            }));

            return;
        }

        // 3) Last fallback: append whatever HTML was returned (shouldn't normally happen)
        container.insertAdjacentHTML('beforeend', html);
    }



  function loadNextPage() {
    if (loading || finished) return;

    if (currentPage >= maxPages) {
      finished = true;
      return;
    }

    loading = true;
    currentPage++;

    const form = new FormData();
    form.append('action', 'load_more_products');
    form.append('page', currentPage);

    const query = ProductsInfiniteVars.query || {};
    ['orderby', 's', 'taxonomy', 'term'].forEach(key => {
        if (query[key]) {
            form.append(key, query[key]);
        }
    });

    let loader = document.getElementById('products-infinite-loader');
    if (!loader) {
        loader = document.createElement('div');
        loader.id = 'products-infinite-loader';
        loader.innerText = 'Ladataan...';
        document.body.appendChild(loader);
    }
    loader.style.display = 'block';

    fetch(ajaxUrl, {
      method: 'POST',
      credentials: 'same-origin',
      body: form
    }).then( response => response.json() ).then( data => {
        if (!data || !data.success) {
            console.error('ProductsInfinite error or empty response', data);
            finished = true;
            return;
        }

        if (data.data.total_results) {
            totalResults = parseInt(data.data.total_results, 10) || 0;
        }

        if (data.data.max_pages) {
            maxPages = parseInt(data.data.max_pages, 10);
        }

        if (!data.data.html || data.data.html.trim() === '') {
            finished = true;
            return;
        }

        appendProducts(data.data.html);

        if (currentPage >= maxPages) {
            finished = true;
        }
        })
    .catch( err => {
      console.error('ProductsInfinite fetch error', err);
    }).finally( () => {
      loading = false;
      if (loader) loader.style.display = 'none';
    });
  }

  let scrollTimer = null;
  window.addEventListener('scroll', function () {
    if (scrollTimer) return;
    scrollTimer = setTimeout(function () {
      scrollTimer = null;
      if (finished) return;
      const nearBottom = (window.innerHeight + window.scrollY) >= (document.body.offsetHeight - 300);
      if (nearBottom) {
        loadNextPage();
      }
    }, 150);
  });

  window.addEventListener('load', function () {
    setTimeout(function tryFill() {
      if (finished) return;
      if ((window.innerHeight + window.scrollY) >= (document.body.offsetHeight - 100)) {
        loadNextPage();
        setTimeout(tryFill, 500);
      }
    }, 400);
  });

});
